module.exports = __webpack_public_path__ + "img/circular-arrows.da549e8d.png";